import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { Navbar } from "./components/layout/Navbar";
import { Footer } from "./components/layout/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Programs from "./pages/Programs";
import Vocational from "./pages/Vocational";
import Admissions from "./pages/Admissions";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import Blog from "./pages/Blog";
import Stories from "./pages/Stories";
import Services from "./pages/Services";
import Accreditation from "./pages/Accreditation";
import Research from "./pages/Research";
import WhyCIU from "./pages/WhyCIU";
import { useEffect } from "react";

// Redirects /apply to the external CNTE portal
function ApplyRedirect() {
  useEffect(() => {
    window.location.replace("https://cnte.ciu.edu.lr/apply");
  }, []);
  return (
    <div className="min-h-screen pt-24 flex items-center justify-center bg-[#F5F5F5]">
      <div className="text-center">
        <p className="text-[#0D4A2E] font-semibold">Redirecting you to our application portal…</p>
        <a href="https://cnte.ciu.edu.lr/apply" className="mt-2 inline-block text-[#C5A028] underline">Click here if you are not redirected automatically</a>
      </div>
    </div>
  );
}

// Wrapper to conditionally hide footer on admin page
function Layout({ children }) {
  const location = useLocation();
  const isAdminPage = location.pathname === '/admin';
  const isApplyPage = location.pathname === '/apply';
  
  return (
    <>
      <Navbar />
      <main>{children}</main>
      {!isAdminPage && !isApplyPage && <Footer />}
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/programs" element={<Programs />} />
              <Route path="/vocational" element={<Vocational />} />
              <Route path="/admissions" element={<Admissions />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:id" element={<Blog />} />
              <Route path="/stories" element={<Stories />} />
              <Route path="/stories/:id" element={<Stories />} />
              <Route path="/services" element={<Services />} />
              <Route path="/accreditation" element={<Accreditation />} />
              <Route path="/research" element={<Research />} />
              <Route path="/why-ciu" element={<WhyCIU />} />
              <Route path="/apply" element={<ApplyRedirect />} />
            </Routes>
          </Layout>
          <Toaster 
            position="top-right"
            toastOptions={{
              style: {
                background: '#0D4A2E',
                color: '#fff',
                borderRadius: '0',
              },
            }}
          />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
